import styles from "./styles.module.scss";
import Footer from "../../components/Footer"
import Header from "../../components/ProcessusPage/Header"
import React, { useRef, useEffect } from 'react'
import Services from "../../components/ProcessusPage/Services";



function Home() {
  const intro = useRef(null)
  const services = useRef(null)
  const processus = useRef(null)
  const value = useRef(null)
  const contact = useRef(null)
  useEffect(() => {
    window.scrollTo(0, 0)
}, [])
  return (
    <>
      <section className={styles.Container}>
        <div className={styles.navBar}>
          <Header intro={intro} services={services} processus={processus} value={value} contact={contact}/>
        </div>      
        <div className={styles.services} ref={services}>
          <Services />
        </div>
        <div className={styles.footer}>
          <Footer />
        </div>
        
      </section>
    </>
  );
}

export default Home;